import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './accordion.css'
import Charts from "../Charts"
import SensorsLastValues from "./SensorsLastValues"
import SensorsTableDays from "./SensorsTableDays"

const MyAccordion = (props) => {
  const {selectedDev, modalChart, t_get_sensor_data_by_date, update_modal_chart } = props
  //console.log(selectedDev.requestData.length ? '1' : '2')
  //console.log(selectedDev.requestData.sensors_card_data?.length)
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!selectedDev.requestData.sensors_card_data?.length ) return null

  return (
    <div className="container mt-5">
    <h2>Sensors info</h2>

    <div id="accordion">
      {/* Header for the first section */}
      <div className="card" style={{ margin: "0" }}>
        <div className="card-header border border-secondary" id="heading1">
          <h5 className="mb-0">
            <button
              className="btn"
              onClick={() => {
                toggleAccordion(0)
                //t_get_stats_restarting_all_devs_by_5days()
              }}
              aria-expanded={openIndex === 0}
              aria-controls="collapse1"
            >
              Data Last Values
            </button>
          </h5>
        </div>

        <div
          id="collapse1"
          className={`collapse ${openIndex === 0 ? 'show' : ''}`}
          aria-labelledby="heading1"
          data-parent="#accordion"
        >
          <div className="card-body">
 
            <SensorsLastValues selectedDev = {selectedDev}
            />
          </div>
        </div>
      </div>

      {/* Header for the second section */}
      <div className="card" style={{ margin: "0" }}>
        <div className="card-header border border-secondary" id="heading2">
          <h5 className="mb-0">
            <button
              className="btn "
              onClick={() => toggleAccordion(1)}
              aria-expanded={openIndex === 1}
              aria-controls="collapse2"
            >
              Data Today Graph
            </button>
          </h5>
        </div>

        <div
          id="collapse2"
          className={`collapse ${openIndex === 1 ? 'show' : ''}`}
          aria-labelledby="heading2"
          data-parent="#accordion"
        >
          <div className="card-body">
            
            <Charts 
              selectedDev = {selectedDev}
            />
          </div>
        </div>
      </div>

      {/* Header for the 3 section */}
      <div className="card" style={{ margin: "0" }}>
        <div className="card-header border border-secondary" id="heading2">
          <h5 className="mb-0">
            <button
              className="btn "
              onClick={() => toggleAccordion(2)}
              aria-expanded={openIndex === 2}
              aria-controls="collapse2"
            >
              Data Table 10 days
            </button>
          </h5>
        </div>

        <div
          id="collapse3"
          className={`collapse ${openIndex === 2 ? 'show' : ''}`}
          aria-labelledby="heading2"
          data-parent="#accordion"
        >
          <div className="card-body">
            <SensorsTableDays 
              selectedDev = {selectedDev}
              modalChart = {modalChart}
              t_get_sensor_data_by_date = {t_get_sensor_data_by_date}
              update_modal_chart={update_modal_chart}
            />
          </div>
        </div>
      </div>

      </div>
    </div>
  );
};

export default MyAccordion;